{
  "#PDF_VIEWER": {
    "NO_DOCUMENT": "No document available for display"
  }
}
